module.exports = __webpack_public_path__ + "static/media/4.6e1fe507.jpg";